import { CityService } from "./city.service";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
@Injectable()
export class SocketProvider {

    constructor(private http: Http) {
        //alert('constructor')

    }


    public getCities(): any {
        return this.cities;
    }

    public cities: any = null;
    init() {
        // Startup logic here
        //alert('SocketService init')
        // this._cityService.getAllCities().subscribe(data => {
        //     this._cityService.cities = (data);
         
        //   });
      }

      load() {
        // return new Promise((resolve, reject) => {
        //     this.http
        //         .get('http://iltlviis02/digLocally/webapi/api/home/ReadAllCities')
        //         .map(res => res.json())
        //         .subscribe(response => {
        //            //debugger
        //             this.cities = response;
        //             resolve(true);
        //         })
        // })
    }
       
}


// WEBPACK FOOTER //
// ./src/app/services/socket.service.ts